import UploadActions from '../actions/upload-actions'
import SelectorActions from '../actions/selector-actions'
import ProductCalculations from './product-calculations'
import OpeOrderItem from '../objects/opeorderitem'
import OpeImageLocal from '../objects/opeimage/local'
import UserStore from '../stores/user-store'
import OrderStore from '../stores/order-store'
import UploadStore from '../stores/upload-store'
import Uploader from './uploader'
import Config from '../config'

//Get the token async when it is available
UserStore.addChangeListener(function () {
    var data = UserStore.getData();
    Uploader.updateToken(data.userToken);
});

function uploadErrorHandler (file, err) {
    if (err.hasOwnProperty("error") && err.error.hasOwnProperty("code")) {
        switch (err.error.code) {
            case 'UNSUPPORTED_FILE_TYPE':
                UploadActions.addUploadError(_("We couldn’t upload the image ‘%s’ because you tried to upload a file type the editor doesn’t support. Supported types are ‘%s’.", file.name, Config.UploadSettings.mimeTypes.join(',')))
                break;
            case 'INVALID_IMAGE':
            case 'GET_IMAGE_DATA_FAILED':
                UploadActions.addUploadError(_("We couldn’t read the image ‘%s’ so it will not be included in your image collection. This might happen if the file is not an image file (for example a jpeg or png), or because the image is broken. Please check the file and try to re-upload it", file.name));
                break;
            case 'MAX_FILE_SIZE':
                UploadActions.addUploadError(_("We couldn’t upload the image ‘%s’ because the image is too large. The maximum file size is %s.", file.name, Config.UploadSettings.maxFileSize));
                break;
            case 'MAX_PHOTO_RESOLUTION':
                var maxPixelSize = Math.round(Math.sqrt(Config.UploadSettings.maxPhotoPixels));
                UploadActions.addUploadError(_("We couldn’t upload the image ‘%s’ because the image is too large. The maximum allowed dimensions are %s x %s pixels.", file.name, maxPixelSize, maxPixelSize));
                break;
            case 'FILE_EXISTS_CHECK_FAILED':
            case 'GENERATE_MD5CHECKSUM_FAILED':
            case 'REGISTRATION_FAILED':
                UploadActions.addUploadError(_("We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again", file.name));
                break;
            case 'GET_UPLOAD_URL_FAILED':
            case 'COMPLETE_UPLOAD_FAILED':
                UploadActions.addUploadError(_("We’re sorry: we couldn’t registrer file %s, so we’ve removed it from your order. This might be a temporary error and you could try uploading it again", file.name));
            case 'UPLOAD_FAILED':
            case 'STORAGE_CORE_RETRIEVE_FAILED':
                logToCentralServer("StandardUploader.uploadErrorHandler#UploadFailed", { regId: file.regId }, 3, err.error.code);
                return;
            case 'CANCELLED':
                break;
            case 'DUPLICATE_MD5_IN_FILES_ADDED':
            case 'DUPLICATE':
                UploadActions.addUploadError(_("%s You’ve already uploaded this photo.", file.name));
                break;
            case 'EMPTY_FILE':
            default:
                UploadActions.addUploadError(_("Some unknown error occurred while uploading image %s", file.name));
                break;
        }
        logToCentralServer("StandardUploader.uploadErrorHandler", err.error.message, 3, err.error.code);
    }

    SelectorActions.removeOrderItemsByImageId(file.localId);
    UploadActions.removeImageFromStore(file.localId);
}

function uploadWarningHandler(file, warning) {
    UploadActions.addUploadWarning(file.localId, warning);
}

function fileRegistered (file) {
    var uploadData = UploadStore.getData();

    //To avoid spamming the views with store updates, we use transactions, so that not all of the updates gives notice.
    if (uploadData.totalImagesRegistered === 0) {
        OrderStore.startTransaction();
    } else if (uploadData.totalImagesRegistered % 10 === 0) {
        OrderStore.stopTransaction();
        OrderStore.startTransaction();
    }
    if (uploadData.totalImagesRegistered + 1 === uploadData.totalImagesToUpload) {
        OrderStore.stopTransaction();
    }

    //Increment register count
    UploadActions.incrementRegisterCount();
}

function fileAddedMultipleTimes (file) {
    //If the image is removed from prints editor by customer, then
    //customer probably wants it back again, so we add it again
    if (ImageStore.getImageById(file.localId) === undefined) {

        //Create image object and add it to the image store
        var image = createOpeImage(file);
        UploadActions.addImageToStore(image);

        //Create order item and add it to the order store
        var item = createOrderItem(file);
        SelectorActions.addOrderItem(item);
    }
}

function createOrderItem (file) {
    //Create order item
    var orderItem = new OpeOrderItem(file.localId, null, {
        quantity: 1,
        "polaroidText": null,
        position: {
            "percentageX": 0,
            "percentageY": 0
        },
        scale: 1.0,
        filter: false,
        filename: file.name,
        imageFilter: {}
    });
    orderItem.resetUpsaleOptions();

    //Calculate which product will suit the image best considering the dimensions of the image
    var selectedProduct = ProductCalculations.autoSelectProduct(file.width,
        file.height,
        sessionStorage.getItem("autoSelectProduct"), sessionStorage.getItem(
            "autoSelectProductWidth"));

    orderItem.setProductId(selectedProduct.productId);
    orderItem.setProductWidth(selectedProduct.productWidth);
    orderItem.setProductHeight(selectedProduct.productHeight);

    // Check the ratio difference of the product selected
    if (selectedProduct.matchRatioDiff > Config.ProductRatioWarning) {
        orderItem.setAutoCropWarning(true);
    }
    // Check DPI of uploaded image
    var imageProductDPI = ProductCalculations.getDPI(selectedProduct, file.width,
        file.height);
    if (imageProductDPI < Config.LowResolutionWarningThreshold) {
        orderItem.setLowResWarning(true);
    }

    orderItem.setPercentage({
        width: file.width,
        height: file.height
    }, true);

    //Figure out if the image is portrait or landscape mode
    var fileAngle = 0;
    var fileFlip = 'NONE';
    try {
        fileAngle = file.filter.rotate.angle,
        fileFlip = file.filter.rotate.flip;
    } catch (e) {

    }

    orderItem.isPortrait = ProductCalculations.isPortrait(file.width, file.height,
        fileAngle, fileFlip);

    //Set the date of when the image was taken (if available)
    orderItem.setImageTakenDate(file.dateTaken);

    //Set a order item id on the file so that other operations can reference it
    file.opeOrderItemId = orderItem.getId();

    return orderItem;
}

function createOpeImage (file) {
    var rotate = 0;
    try {
        rotate = file.filter.rotate.angle;
    } catch (e) { //Intentionally ignored
    }
    // On occasion, a rotated image is presented with an extra 90 degrees rotation due to exif
    // data mixup with actual image dimensions. Thumbnails, however, do not suffer from this issue
    // so thumbnail size can be used as a secondary validation of the image orientation
    try {
        var firstThumb = file.storageCoreData.thumbnails[0]
        var firstThumbIsPortrait = (firstThumb.width / firstThumb.height) < 1
        var imageIsPortrait = (file.width / file.height) < 1
        if ((rotate === 90 || rotate === 270) && imageIsPortrait === firstThumbIsPortrait) {
            // In case there's a 90-degree rotation and the image native size is the same aspect as the thumbnail
            // "cancel" the rotation
            rotate = 0;
            try { file.filter.rotate.angle = 0; } catch(e) {}
        }
    } catch(e) {}

    if (rotate === 90 || rotate === 270) {
        return new OpeImageLocal(file.localId, file, file.height, file.width);
    } else {
        return new OpeImageLocal(file.localId, file, file.width, file.height);
    }
}

function storageCoreDataRecieved(file) {
    //Create image object and add it to the image store
    var image = createOpeImage(file);
    UploadActions.addImageToStore(image);

    //Create order item and add it to the order store
    var item = createOrderItem(file);
    SelectorActions.addOrderItem(item);

    UploadActions.setServerData(file.localId, file.storageCoreData);
}

// for logging, we want to send data only for uploaded sessions. upload sdk can return total uploaded
// multiple times, hence we need to distinguish between amount of photos uploaded on new batch and old batch
// so we keep old batch of photos on this variables
var prevTotalImagesFailed = 0;
var prevTotalImagesUploaded = 0;

function doneUploadingEvent() {
    var uploadData = UploadStore.getData();
    var uploadStatistics = {
        totalImagesFailed: uploadData.totalImagesFailed - prevTotalImagesFailed,
        totalImagesUploaded: uploadData.totalImagesUploaded - prevTotalImagesUploaded
    };
    // get new value for cache
    prevTotalImagesFailed = uploadData.totalImagesFailed;
    prevTotalImagesUploaded = uploadData.totalImagesUploaded;
    logToCentralServer("StandardUploader.uploadDone", uploadStatistics, 1);
}

function fileAddedHandler() {
}

//Attach event listeners to the uploader
Uploader.fileAddedEvent(fileAddedHandler);
Uploader.statisticsUpdatedEvent(UploadActions.updateStatistics);
Uploader.uploadErrorEvent(uploadErrorHandler);
Uploader.fileRegisteredEvent(fileRegistered);
Uploader.fileAddedMultipleTimesEvent(fileAddedMultipleTimes);
Uploader.uploadWarningEvent(uploadWarningHandler);
Uploader.storageCoreDataRecievedEvent(storageCoreDataRecieved);
Uploader.doneUploadingEvent(doneUploadingEvent);
